import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth.service';
import { NiveauLivreurService, StatsLivreurDTO } from 'src/app/core/services/niveau-livreur.service';

@Component({
  selector: 'app-livreur-bilan',
  templateUrl: './livreur-bilan.component.html',
  styleUrls: ['./livreur-bilan.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LivreurBilanComponent implements OnInit {

  stats: StatsLivreurDTO | null = null;
  chargement = true;
  erreur = '';
  nomLivreur = '';

  readonly MOIS_FR = ['Janvier','Février','Mars','Avril','Mai','Juin',
                      'Juillet','Août','Septembre','Octobre','Novembre','Décembre'];

  get moisLabel(): string {
    return this.MOIS_FR[new Date().getMonth()];
  }

  constructor(
    private service: NiveauLivreurService,
    private auth: AuthService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    const u = this.auth.obtenirUtilisateurCourant();
    this.nomLivreur = u ? `${u.prenom || ''} ${u.nom || ''}`.trim() : '';
    if (u?.userid) {
      this.service.getStats(u.userid).subscribe({
        next: s => { this.stats = s; this.chargement = false; this.cdr.markForCheck(); },
        error: () => { this.erreur = 'Impossible de charger vos statistiques.'; this.chargement = false; this.cdr.markForCheck(); }
      });
    } else {
      this.erreur = 'Session invalide. Reconnectez-vous.';
      this.chargement = false;
      this.cdr.markForCheck();
    }
  }

  get palierCouleur(): string {
    return this.stats?.palier.couleur || '#888';
  }

  get progressPct(): number {
    return Math.round((this.stats?.palier.progression ?? 0) * 100);
  }

  get gainsMoisFormates(): string {
    return this.formatNombre(this.stats?.mois.gains ?? 0);
  }

  get gainsProjectesFormates(): string {
    return this.formatNombre(this.stats?.mois.gainsProjectes ?? 0);
  }

  get primeProjeteeFormatee(): string {
    return this.formatNombre(this.stats?.mois.primeProjetee ?? 0);
  }

  private formatNombre(v: number): string {
    if (v >= 1_000_000) return (v / 1_000_000).toFixed(1).replace('.0','') + 'M';
    if (v >= 1_000)     return (v / 1_000).toFixed(0) + 'K';
    return v.toString();
  }
}
